module.exports = __webpack_public_path__ + "static/media/66.df373aa3.jpg";